import React from "react";
import { useI18n, NLink } from "@/i18n/I18nProvider";

const IMG = "https://images.pexels.com/photos/35564755/pexels-photo-35564755.jpeg";

const SuccessStories = () => {
  const { t } = useI18n();
  return (
    <>
      <section
        className="relative grain bg-[#0F1B2D] text-white pt-36 pb-24"
        style={{
          backgroundImage: `linear-gradient(rgba(15,27,45,0.8), rgba(15,27,45,0.95)), url(${IMG})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
          <div className="overline text-[#C4A46A]">{t.success.kicker}</div>
          <h1 className="mt-6 font-display text-4xl sm:text-5xl lg:text-6xl tracking-tight">
            {t.success.title}
          </h1>
          <span className="gold-rule mt-8 block" />
        </div>
      </section>

      <section className="bg-[#F4F0E8]">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-12 py-24 grid grid-cols-1 lg:grid-cols-12 gap-10">
          <div className="lg:col-span-7">
            <p className="font-display text-2xl lg:text-3xl text-[#0F1B2D] leading-snug tracking-tight">
              {t.success.placeholder}
            </p>
            <span className="gold-rule mt-8 block" />
            <p className="mt-8 text-[#5E6470] leading-relaxed max-w-2xl">
              {t.common.tagline}
            </p>
          </div>
          <div className="lg:col-span-5">
            <div className="bg-[#0F1B2D] text-white p-10">
              <div className="overline text-[#C4A46A]">{t.common.taglineSecondary}</div>
              <h3 className="mt-3 font-display text-2xl tracking-tight">{t.nav.bookCta}</h3>
              <span className="gold-rule mt-4 block" />
              <p className="mt-6 text-white/70 leading-relaxed">
                {t.home.ctaBlockBody}
              </p>
              <NLink
                to="/contact"
                data-testid="success-cta"
                className="mt-8 inline-flex px-6 py-3 bg-[#C4A46A] text-[#0F1B2D] text-[12px] tracking-[0.24em] uppercase font-bold hover:bg-[#A38755] transition-colors"
              >
                {t.nav.bookCta}
              </NLink>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default SuccessStories;
